<template>
  <div class="container" @scroll="remPos" ref="boxs">
    <van-nav-bar
      fixed
      title="文章详情"
      left-arrow
      @click-left="$router.back()"
    />
    <div class="header">
      <div @click="returnBtn">
        <img
          src="http://shenghuoribao.oss-cn-beijing.aliyuncs.com/logo.png"
          class="logo"
        />
        <span class="slogan">生活融媒</span>
      </div>
    </div>
    <div class="header-2">
          <div>
             <span class="slogan-index" @click="returnBtn">首页</span>
            <img src="http://shenghuoribao.oss-cn-beijing.aliyuncs.com/back.png" class='back'></img>
            <span class="slogan-category">{{detail.categorys.name}}</span>
          </div>
          <div class="box">
              <div @click="shareFriend"><img src="http://shenghuoribao.oss-cn-beijing.aliyuncs.com/shareImg.png"></img></div>
            <!-- <button @click="shareGroup">分享朋友圈</button> -->
          </div> 
    </div>

    <div class="detail">
      <div class="title">{{ detail.title }}</div>
      <div class="author">
        <!-- <van-image
          round
          width="1rem"
          height="1rem"
          fit="fill"
          :src="detail.aut_photo"
        /> -->
        <div class="text">
          <p class="name">{{ detail.aouther }} · {{ detail.updatetime }} <span class="read-num">浏览: {{detail.read_num}} </span></p>
        </div>
        <!-- 关注 -->
        <!-- <van-button round size="small" type="info" @click="toggleFollow">{{
          detail.is_followed ? "已关注" : "+关注"
        }}</van-button> -->
      </div>
      <div v-if="is_video" class="video-play">
        <video-player
          class="video-player-box video-player vjs-custom-skin"
          ref="videoPlayer"
          :options="playerOptions"
          :playsinline="true"
          customEventName="customstatechangedeventname"
          @play="onPlayerPlay($event)"
          @pause="onPlayerPause($event)"
          @ended="onPlayerEnded($event)"
          @waiting="onPlayerWaiting($event)"
          @playing="onPlayerPlaying($event)"
          @loadeddata="onPlayerLoadeddata($event)"
          @timeupdate="onPlayerTimeupdate($event)"
          @canplay="onPlayerCanplay($event)"
          @canplaythrough="onPlayerCanplaythrough($event)"
          @statechanged="playerStateChanged($event)"
          @ready="playerReadied"
        />
      </div>
      <div class="content">
        <p class="content" v-html="detail.content"></p>
      </div>
    </div>
    <div class="relation-article">
      <div class="relation-title">相关推荐</div>
      <div  class="relation-box"  v-for="item in  relationData" @click="toDetail(item.id)">
          <div class="relation-content">
            <img src="item.sources[0].img_url" :onerror="defaultImg"></img>
            <div class="relation-tag">
            {{item.title}}
          </div>
          </div>
          
      </div>

    </div>
 
  </div>
</template>

<script>
import { getDetailById, getRelationArticle } from "@/api/detail";
import { getWxConfig } from "../../api/share";
import wx from "weixin-js-sdk";
// 关注和取关 is_followedme  默认是false
// import { follow, unFollow, disLike, unDisLike, like, unLike } from "@/api/user";
// import Comment from './components/comment.vue'
export default {
  name: "articles",
  data() {
    return {
      detail: {}, // 文章详情信息
      scrollTop: 0, // 滚动位置,
      is_video: false,
      relationData:[],
       defaultImg: 'this.src="http://shenghuoribao.oss-cn-beijing.aliyuncs.com/logo.png"',
      playerOptions: {
        muted: true,
        language: "zh-CN",
        muted: false,
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        preload: "auto",
        aspectRatio: "16:9",
        sources: [
          {
            type: "video/mp4",
            src: "",
          },
        ],
        poster: "/static/images/author.jpg",
      },
    };
  },
  computed: {
    //  player() {
    //     return this.$refs.videoPlayer.player
    //   }
  },
  // 之前有meta对文章缓存 组件缓存后会被执行：
  // 1. 默认第一次组件创建也会执行 2. 再次进入还会再执行
  activated() {
    // 不能盲目缓存
    // 上次访问的文章ID和下次访问的文章ID不一样
    // 但只能记录一个文章详情的
    if (this.detail.art_id !== this.$route.params.id) {
      // 新的文章重置滚动位置
      this.scrollTop = 0;
      // 进入缓存的组件就会重新获取最新数据 时效性
      this.getDetail();
      /**
       * 记录用户阅读文章滚动位置=》被缓存文章（1）
       * 1. 通过scroll滚动事件存储滚动位置
       * 2. 下次再回来回到上次阅读位置
       */
    } else {
      // 执行滚动（阅读记忆）返回之前缓存的文章组件
      this.scrollTop && (this.$refs.boxs.scrollTop = this.scrollTop);
    }
  },
  // created () {
  //   this.getDetail()
  // },
  methods: {
   
   toDetail(id){
      this.$route.params.id=id;
     this.getDetail();
     window.scrollTo(0,0);
      // this.$router.push({ path:'/article/'+id  })
   },
    // 获取文章详情
    async getDetail() {
      const { data } = await getDetailById({ id: this.$route.params.id });
      if (data.video_uri != null) {
        this.is_video = true;
        (this.playerOptions.poster = data.sources[0].image_uri),
          (this.playerOptions.sources[0].src = data.video_uri);
      }
      this.detail = data;
      this.getRelationArticle();
    },
    async getRelationArticle() {
      const { data } = await getRelationArticle({
        ids: this.detail.relation_ids?this.detail.relation_ids:'',
      });
     
      this.relationData=data;
      //  console.log(this.relationData[1].sources.length)

    },
    returnBtn() {
      this.$router.push({ path: "/" });
      return false;
    },

    getSignature() {
      return new Promise((resolve, reject) => {
        getWxConfig({
          url: window.location.href.split("#")[0],
        })
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async shareFriend() {
      let res = await this.getSignature();
      let { timestamp, nonceStr, app_id, signature } = res;
      wx.config({
        debug: false,
        appId: app_id,
        timestamp: timestamp,
        nonceStr: nonceStr,
        signature: signature,
        jsApiList: ["updateAppMessageShareData", "updateTimelineShareData","onMenuShareAppMessage","onMenuShareTimeline","onMenuShareQQ"],
      });
       const shareData = {
          title: this.detail.title+"【生活融媒】",
          desc: this.detail.content.replace(/<[^>]+>|&[^>]+;/g, "").trim().slice(0, 150),
          link: window.location.href.split("#")[0],
          imgUrl: this.detail.sources.length>0?this.detail.sources[0].image_uri: "http://m.shenghuoribao.com/logo.png",
          success: function (res) {
            console.log("调用成功:",res);
          },
        };
      wx.checkJsApi({
        jsApiList: ["updateAppMessageShareData", "updateTimelineShareData","onMenuShareAppMessage","onMenuShareTimeline","onMenuShareQQ"],
        success: function (res) {
          console.log(res);
        },
      });
      wx.ready(() => {
        console.log('shareData',shareData);
        wx.updateAppMessageShareData(shareData);
        wx.updateTimelineShareData(shareData);
        wx.onMenuShareTimeline(shareData);
        wx.onMenuShareAppMessage(shareData);
        wx.onMenuShareQQ(shareData);
        wx.onMenuShareWeibo(shareData);
        wx.onMenuShareQZone(shareData);
      });
      wx.error(function (res) {
        console.log("res-------",res);
      });
    },
    // 阅读记忆----操作DOM
    remPos(e) {
      this.scrollTop = e.target.scrollTop;
    },
    //  发起请求当dateil中的is_followed 为true表示已关注点击取关后，数据库已经取关前端也要取关 反之
    async toggleFollow() {
      try {
        if (this.detail.is_followed) {
          // 取关
          // 数据库
          await unFollow(this.detail.aut_id);
          // 前端
          this.detail.is_followed = false;
        } else {
          // 关注
          // 后台数据库
          await follow(this.detail.aut_id);
          // 前端
          this.detail.is_followed = true;
        }
      } catch (error) {
        // 捕获其他错误
        this.$toast.fail("操作失败");
      }
    },
    // 对文章表态：attitude -1: 无态度，0-不喜欢，1-点赞（喜欢）=> 3选1
    // type=> 1 点击了点赞按钮 0 点击了不喜欢按钮
    // 不选
    // 选了 为1喜欢可以掉接口取消添加 数据库+前端            为0不喜欢可以掉接口取消添加 数据库+前端
    // this.detail.attitude核心
    async toggleLike(type) {
      try {
        if (type === 1) {
          if (this.detail.attitude === 1) {
            // 取消/点赞 文章
            await disLike(this.detail.art_id);
            this.detail.attitude = -1;
          } else {
            await unDisLike(this.detail.art_id);
            this.detail.attitude = 1;
          }
        } else {
          // 写不喜欢逻辑
          if (this.detail.attitude === 0) {
            // 取消不喜欢
            await like(this.detail.art_id);
            this.detail.attitude = -1;
          } else {
            // 不喜欢
            await unLike(this.detail.art_id);
            this.detail.attitude = 0;
          }
        }
      } catch (error) {
        console.dir(error);
        this.$toast.fail("操作失败");
      }
    },
  },
  components: {
    // Comment
  },
};
</script>

<style scoped lang='less'>
.container {
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  background-color: #f4f6f8;
  .video-play {
    width: 100%;
  }
  .relation-article{
      background-color: #fff;
      .relation-box{
        margin:0.2rem;
        border-bottom: #f4f6f8 1px solid;
      }
    
    .relation-title{
      font-size:0.5rem;
      margin:10px;
      padding-top:0.3rem
      
    }
    .relation-content{
      display: flex;
      .relation-tag{
        font-size: 0.4rem;
        margin-left:0.2rem ;
      }
        img{
          width: 60px;
          height: 60px;
          margin:0.2rem;
        }
    }
  }
  

  .header {
    background-color: #fff;
    height: 1rem;
    position: relative;
    z-index: 99;
    .logo {
      width: 0.72rem;
      height: 0.72rem;
      position: absolute;
      margin: 0.14rem 0;
      left: 0.4rem;
      border: 0.02rem solid #eee;
      border-radius: 0.14rem;
    }
  }
  .slogan {
    font-size: 0.38rem;
    color: #222;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 1.4rem;
    line-height: 1rem;
  }
}
.header-2 {
  background-color: #fff;
  height: 1rem;
  position: relative;
  z-index: 99;
  .back {
    width: 0.45rem;
    height: 0.45rem;
    position: absolute;
    margin: 0.25rem 0;
    left: 1.2rem;

    // border: 0.02rem solid #eee;
    border-radius: 0.14rem;
  }
  .box {
    width: 0.72rem;
    height: 0.72rem;
    position: absolute;
    margin: 0.25rem 0;
    right: 0.4rem;
    // border: 0.02rem solid #eee;
    border-radius: 0.14rem;
    img {
      width: 0.45rem;
      height: 0.45rem;
    }
  }
  .slogan-index {
    font-size: 0.38rem;
    color: #222;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0.4rem;
    line-height: 1rem;
  }
  .slogan-category {
    font-size: 0.38rem;
    color: #222;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 1.8rem;
    line-height: 1rem;
  }
}
.detail {
  padding: 5px 10px 5px 5px;
  .title {
    line-height: 1rem;
    font-weight: 700;
    color: #222;
    font-size: 0.6rem;
    margin-bottom: 0.32rem;
  }
  .zan {
    text-align: center;
    padding: 10px 0;
    .active {
      border-color: red;
      color: red;
    }
  }
  .author {
    padding: 2px 0;
    display: flex;
    .text {
      flex: 1;
      padding-left: 10px;
      line-height: 1.5;
      text-align: left;
      .name {
        font-size: 14px;
        margin: 0;
        color: #999;
      }
      .time {
        margin: 0;
        font-size: 12px;
        color: #999;
      }
      .read-num {
        margin-left: 14px;
      }
    }
  }
  // 内容中包含：img 特别宽  code pre 不能换行
  .content {
    padding: 6px 0;
    overflow: hidden;
    white-space: pre-wrap;
    word-break: break-all;
    background-color:#FFFFFF;
    /deep/ img {
      max-width: 100%;
      background: #f9f9f9;
    }
    /deep/ code {
      white-space: pre-wrap;
    }
    /deep/ pre {
      white-space: pre-wrap;
    }
  }
}
</style>
